import { render, staticRenderFns } from "./SendToWaddr.vue?vue&type=template&id=04d10593&"
import script from "./SendToWaddr.vue?vue&type=script&lang=js&"
export * from "./SendToWaddr.vue?vue&type=script&lang=js&"
import style0 from "./SendToWaddr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports